module.exports = __webpack_public_path__ + "img/raj.fe4a920b.jpg";